var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "table",
    {
      staticClass: "default",
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("thead", [
        _c(
          "tr",
          {
            staticClass: "sortable",
          },
          [
            _c("th", [_vm._v(_vm._s(_vm.$gettext("Typ")))]),
            _vm._v(" "),
            _c(
              "th",
              {
                class: _vm.getSortClass("name"),
                on: {
                  click: function click($event) {
                    return _vm.sort("name")
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "#",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$gettext("Name")))]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                class: _vm.getSortClass("size"),
                on: {
                  click: function click($event) {
                    return _vm.sort("size")
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "#",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$gettext("Größe")))]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "responsive-hidden",
                class: _vm.getSortClass("owner"),
                on: {
                  click: function click($event) {
                    return _vm.sort("owner")
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "#",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$gettext("Autor/-in")))]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                class: _vm.getSortClass("mkdate"),
                on: {
                  click: function click($event) {
                    return _vm.sort("mkdate")
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "#",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$gettext("Datum")))]
                ),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.empty
        ? _c("tbody", [
            _c(
              "tr",
              {
                staticClass: "empty",
              },
              [
                _c(
                  "td",
                  {
                    attrs: {
                      colspan: "5",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$gettext("Dieser Ordner ist leer")))]
                ),
              ]
            ),
          ])
        : [
            _c(
              "tbody",
              {
                staticClass: "subfolders",
              },
              _vm._l(_vm.sortedFolders, function (folder) {
                return _c("file-chooser-folder-item", {
                  key: folder.id,
                  attrs: {
                    folder: folder,
                    tag: "tr",
                  },
                })
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "tbody",
              {
                staticClass: "files",
              },
              _vm._l(_vm.sortedFiles, function (file) {
                return _c("file-chooser-file-item", {
                  key: file.id,
                  attrs: {
                    file: file,
                    tag: "tr",
                  },
                  on: {
                    selectId: function selectId($event) {
                      return _vm.$emit("selectId")
                    },
                  },
                })
              }),
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("colgroup", [
      _c("col", {
        staticStyle: {
          width: "36px",
        },
      }),
      _vm._v(" "),
      _c("col"),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "100px",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticClass: "responsive-hidden",
        staticStyle: {
          width: "150px",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "126px",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }